import React from 'react';
import { type ProductStatusType } from '@/common/types/product-status.type';
import classNames from 'classnames';
import CustomImage from '@/common/components/custom-image';
import DiagonalLine from '@/common/components/diagonal-line';
import Tag from '@/common/components/tag/tag.component';
import { perisanProductStatusConstant } from '@/common/constants/perisan-product-status.constant';

interface DisplayProps {
  productStatus?: ProductStatusType;
  thumbnailImage: string | null;
  availability: string;
  discount?: number;
}

function ProductDisplay({
  availability,
  thumbnailImage,
  discount,
}: DisplayProps) {
  const notInStock = availability === 'OutOfStock';
  const shouldDisplayTag = availability === 'InStock' && discount;

  return (
    <div className={classNames('mb-2 h-[158px] w-full lg:h-[212px]')}>
      <div className="relative h-full w-full overflow-hidden rounded-md border-[0.5px] border-silver-400 lg:rounded-2xl">
        {notInStock && <DiagonalLine />}
        {thumbnailImage && (
          <CustomImage
            alt="تصویر محصول"
            src={thumbnailImage}
            className={classNames(
              'absolute inset-0 h-full w-full object-cover lg:rounded-2xl',
              {
                'opacity-50': notInStock,
              }
            )}
            objectFit="cover"
            width={100}
            height={100}
          />
        )}
        <div className="">
          {notInStock && availability.length ? (
            <Tag className="absolute bottom-2 right-0 z-40 ">
              {
                perisanProductStatusConstant[
                  availability.toLocaleUpperCase() as keyof typeof perisanProductStatusConstant
                ]
              }
            </Tag>
          ) : null}
          {shouldDisplayTag ? (
            <Tag className="ltr absolute bottom-2 right-0 z-40 flex flex-col">
              {discount}%
            </Tag>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default ProductDisplay;
